import { IconProps } from "../../../types/style";

const EditIconSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.9911 3.27123L8.11105 11.1512C7.81105 11.4512 7.51105 12.0412 7.45105 12.4712L7.02105 15.4812C6.86105 16.5712 7.63105 17.3312 8.72105 17.1812L11.7311 16.7512C12.1511 16.6912 12.7411 16.3912 13.0511 16.0912L20.9311 8.21123C22.2911 6.85123 22.9311 5.27123 20.9311 3.27123C18.9311 1.27123 17.3511 1.91123 15.9911 3.27123Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.9102 4.15002C15.5802 6.54002 17.4502 8.41002 19.8502 9.09002"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default EditIconSVG;
